import React from 'react'
import type { IntlShape } from 'react-intl'
import Image from 'components/Common/Image'

export function getStepsHowItWorks(intl: IntlShape) {
  return [
    {
      image: <Image style={{ height: 40 }} id="tcqw0293hnq17bzcd78d" alt="Step 1" quality="eco" />,
      title: intl.formatMessage({
        id: 'TuctdW4jDy',
        defaultMessage: 'Pay in four instalments over six weeks.',
        description: 'Step 1 title for How it works section on Afterpay landing page',
      }),
      description: intl.formatMessage({
        id: 'Z7S4fZpiaJ',
        defaultMessage: 'Pay your first instalment at the time of purchase, and the rest every two weeks.',
        description: 'Step 1 description for How it works section on Afterpay landing page',
      }),
    },
    {
      image: <Image style={{ height: 40 }} id="2ejw6szt8h4fesu9j1s" alt="Step 2" quality="eco" />,
      title: intl.formatMessage({
        id: 'zCejH/lmDm',
        defaultMessage: 'Enjoy no fees when you pay on time.',
        description: 'Step 2 title for How it works section on Afterpay landing page',
      }),
      description: intl.formatMessage({
        id: 'gzGNeBV/i/',
        defaultMessage: 'The only fees are late payments but, don\u2019t worry, Afterpay will send regular reminders.',
        description: 'Step 2 description for How it works section on Afterpay landing page',
      }),
    },
    {
      image: <Image style={{ height: 40 }} id="zndk0xexpwvqcsq6b84" alt="Step 3" quality="eco" />,
      title: intl.formatMessage({
        id: 'azSHyL2xhP',
        defaultMessage: 'Get instant approval in seconds.',
        description: 'Step 3 title for How it works section on Afterpay landing page',
      }),
      description: intl.formatMessage({
        id: 'xIwLrmUsRo',
        defaultMessage: 'Know you\u2019ve been approved almost instantly.',
        description: 'Step 3 description for How it works section on Afterpay landing page',
      }),
    },
  ]
}

export function getStepsBuyNow(intl: IntlShape) {
  return [
    {
      title: '1',
      description: intl.formatMessage({
        id: 'R3eR6R+zlO',
        defaultMessage: 'Browse your favourite escapes',
        description: 'Step 1 description for Buy now section on Afterpay landing page',
      }),
    },
    {
      title: '2',
      description: intl.formatMessage({
        id: 'rVqUqvwoK1',
        defaultMessage: 'Instantly create an account and complete your purchase',
        description: 'Step 2 description for Buy now section on Afterpay landing page',
      }),
    },
    {
      title: '3',
      description: intl.formatMessage({
        id: 'FDeZXJY8cy',
        defaultMessage: 'Choose Afterpay as your payment method',
        description: 'Step 3 description for Buy now section on Afterpay landing page',
      }),
    },
  ]
}
